import { render, staticRenderFns } from "./WhatsappContact.vue?vue&type=template&id=5059073e&scoped=true"
import script from "./WhatsappContact.vue?vue&type=script&lang=js"
export * from "./WhatsappContact.vue?vue&type=script&lang=js"
import style0 from "./WhatsappContact.vue?vue&type=style&index=0&id=5059073e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5059073e",
  null
  
)

export default component.exports